var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container clear"},[_c('div',{ref:"videoWrap",staticClass:"video-left f-left",attrs:{"id":"video-wrap"}}),_c('div',{staticClass:"f-right chapters"},[_c('CourseChapter',{attrs:{"course":_vm.course,"currentPeriod":_vm.period_id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }